module.exports = __webpack_public_path__ + "static/media/LoginPage.d5a48afb.jpeg";